<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Participant</a></li> -->
              <li class="breadcrumb-item active">Participant</li>
            </ol>
          </div>
          <h4 class="page-title">Participant Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">

          <h4 class="header-title">Participants</h4>
          <p class="sub-header">
            Create new participants for your current participant
          </p>

          <div class="row">

            <div class="col-12">
              <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="syncParticipants()"> <i class="mdi mdi-refresh"></i> </button>
            </div>

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                <thead>
                <tr>
                  <th>Participant Name</th>
                  <th>Postillion Id</th>
                  <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let participantAndPermissions of participants">
                    <td>{{ participantAndPermissions.name }}</td>
                    <td>{{ participantAndPermissions.id }}</td>
                    <td>
                      <div *ngIf="canEdit" class="dropdown fa-pull-right">
                        <button id="dropdownMenuButton" type="button" *ngIf="canEdit" class="btn btn-icon waves-effect waves-light btn-outline-primary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          Edit
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <span class="dropdown-item clickable" (click)="editSinkNode(participantAndPermissions)">Sink node mapping</span>
                          <span class="dropdown-item clickable" (click)="editProductProfiles(participantAndPermissions)">Product profiles</span>
                          <span class="dropdown-item clickable" (click)="editCommsProfile(participantAndPermissions)">Comms profiles</span>
                          <span class="dropdown-item clickable" (click)="editTerminalCapabilities(participantAndPermissions)">Terminal Capabilities</span>
                          <span class="dropdown-item clickable" (click)="editCardSets(participantAndPermissions)">Card sets</span>
                          <span class="dropdown-item clickable" (click)="editParticipant(participantAndPermissions)">Participant</span>
                          <span class="dropdown-item clickable" (click)="editVAS(participantAndPermissions)">VAS configuration</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
